"use strict";

require("../../style/index.less");

require("./index.less");

require("../../button/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/input/style/index.js
// module id = 23
// module chunks = 1